"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// This will need to keep in sync with the `ReactCSSTransitionGroupChild` `TICK` const.
// https://github.com/facebook/react/blob/master/src/addons/transitions/ReactCSSTransitionGroupChild.js#L22

exports.default = 17;
//# sourceMappingURL=CSSTransitionGroupTick.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/constants/CSSTransitionGroupTick.js
// module id = 30
// module chunks = 42657473041956 79611799117203 201563372448855 213534597649335